export default "__VITE_ASSET__DLMDhoaq__"